export default {
  HIOPOSWEBSERVICES: 'https://hiopos-dev.saas.com.co',
  HIOPOSREPORTS: 'https://hioposreports-co.saas.com.co',
}
